import {environment} from '@root/src/environments/environment';
import {MapInitOptions} from '../interfaces';
import {IBaseLayerConfig} from '../controllers/map-layers.controller';

const OSM_FALLBACK_MAP_LAYERS: IBaseLayerConfig = {
  plan: {
    name: 'Plan',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '© OpenStreetMap contributors',
  },
  satellite: {
    name: 'Satellite',
    url: 'https://mt{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
    subdomains: ['0', '1', '2', '3'],
    attribution: '© Google',
  },
  google: {
    name: 'Satellite',
    url: 'https://mt{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
    subdomains: ['0', '1', '2', '3'],
    attribution: '© Google',
  },
  sentinel: {
    name: 'Sentinel',
    url: 'https://maps.heigit.org/openmapsurfer/tiles/EOX_S2cloudless_3857/{z}/{x}/{y}.jpg',
    attribution: '© ESA/Copernicus',
  },
  landsat: {
    name: 'Landsat',
    url: 'https://landsat.usgs.gov/arcgis/rest/services/Landsat_8_OLI_TIRS_C1/ImageServer/tile/{z}/{y}/{x}',
    attribution: '© USGS/NASA Landsat',
  },
};

export function resolveOsmMapLayers(): IBaseLayerConfig {
  return environment.mapLayers || OSM_FALLBACK_MAP_LAYERS;
}

export function createDefaultOsmMapOptions(): MapInitOptions {
  return {
    height: '400px',
    center: [
      environment.map.center?.lat ?? environment.map.lat,
      environment.map.center?.lng ?? environment.map.lng,
    ],
    zoom: 13,
    showControls: true,
    minimalControls: false,
    drawingMode: false,
    showDrawingControls: true,
    baseMap: 'osm',
    showRegionNames: true,
    disableBounds: false,
  };
}
